import {
  observeElementInsertion,
  waitForElementDefined,
} from './notifications-helpers';
import { inject } from '@angular/core';
import {
  AuthEvent,
  AuthService,
  ConfigService,
  LuigiCoreService,
} from '@openmfp/portal-ui-lib';
import { filter, take } from 'rxjs';

export function initNotifications() {
  const authService = inject(AuthService);
  const configService = inject(ConfigService);
  const luigiCoreService = inject(LuigiCoreService);

  authService.authEvents
    .pipe(
      filter((event) => event === AuthEvent.AUTH_SUCCESSFUL),
      take(1),
    )
    .subscribe({
      next: async () => {
        const config = await configService.getPortalConfig();

        try {
          if (document.documentElement?.nodeName !== 'HTML') {
            console.warn('Not an HTML document');
            return;
          }

          const scriptElement = document.createElement('script');
          scriptElement.async = true;
          scriptElement.type = 'module';
          scriptElement.src = `${config.portalContext.notificationsUIUrl}/main.js`;

          scriptElement.onerror = (e) => {
            console.error('Notifications script failed to load', e);
          };
          document.body.appendChild(scriptElement);
          await waitForElementDefined('notifications-component');
          await addNotificationsComponent(luigiCoreService, authService);
        } catch (err) {
          console.error('Notifications script failed to load', err);
        }
      },
    });
}

export async function addNotificationsComponent(
  luigiCoreService: LuigiCoreService,
  authService: AuthService,
) {
  const notificationAnchor = await observeElementInsertion(
    '[data-testid="dxp-notification-anchor"]',
  );

  // Skip adding notifications component for testing tenant
  const testTenantId = '01ezesr3cgghmhgpbny04hv8qn';
  if (luigiCoreService.getGlobalContext().tenantid === testTenantId) {
    return;
  }

  if (notificationAnchor) {
    const webComponent = document.createElement('notifications-component');
    notificationAnchor.after(webComponent);

    if (!webComponent) {
      console.error('Failed to create notifications-component element.');
      return;
    }

    const globalCtx = luigiCoreService.getGlobalContext();
    (webComponent as any).context = {
      token: globalCtx.token,
      apiUrl: globalCtx.portalContext?.['notificationsServiceApiUrl'],
    };

    authService.authEvents
      .pipe(filter((event) => event === AuthEvent.AUTH_REFRESHED))
      .subscribe(() => {
        const newToken = authService.getToken();
        (webComponent as any).context = {
          token: newToken,
        };
      });
  }
}
